import type { IOptionModel } from '@/models/option';

export enum SsoMappingType {
  None = 0,
  ExtensionAttribute = 1,
  Groups = 2
}

export const SsoMappingTypeOptions: IOptionModel<number>[] = [
  { label: 'core.sso_mapping_type.none', value: SsoMappingType.None },
  { label: 'core.sso_mapping_type.extension_attribute', value: SsoMappingType.ExtensionAttribute },
  { label: 'core.sso_mapping_type.groups', value: SsoMappingType.Groups },
];
